import aliases from './resource-aliases'

export default resource => Object.keys(aliases)
  .reduce((finalResource, alias) => finalResource.replace(new RegExp(alias, 'g'), aliases[alias]), resource)
